@if (jackpotGroupId) {
    <cc-casino-core-lazy-placeholder
        [inputData]="{
            categoryId: categoryId,
            lobbyType: lobbyType,
            category: category,
            isTouch: isTouch,
            gameContainer: gameContainer,
        }"
        [componentName]="'JackpotTileConatinerComponent'">
    </cc-casino-core-lazy-placeholder>
} @else {
    @if (displayBetMGMOriginals) {
        <div class="category-Level-Originals">
            <cc-casino-core-lazy-placeholder
                [inputData]="{ isSubCategory: true, lobbyType: lobbyType, category: category }"
                [componentName]="'BetMGMOriginalsComponent'">
            </cc-casino-core-lazy-placeholder>
        </div>
    }
    <span [ngSwitch]="categoryId">
        <ng-container *ngIf="isSlotRacesPhase2Enabled">
            <cc-casino-core-lazy-placeholder
                *ngSwitchCase="slotRacesCategoryId"
                [inputData]="{ component: 'page', lobbyType: lobbyType, category: category }"
                [componentName]="'SlotRacesPhase2Component'">
            </cc-casino-core-lazy-placeholder>
        </ng-container>
        <ng-container *ngIf="!isSlotRacesPhase2Enabled">
            <cc-casino-core-lazy-placeholder
                *ngSwitchCase="slotRacesCategoryId"
                [inputData]="{ component: 'page', lobbyType: lobbyType, category: category }"
                [componentName]="'SlotRacesComponent'">
            </cc-casino-core-lazy-placeholder>
        </ng-container>
        <cc-casino-core-lazy-placeholder
            *ngSwitchCase="discoverFeedLmtkey"
            [inputData]="{ categoryId: categoryId, lobbyType: lobbyType }"
            [componentName]="'DiscoverFeedComponent'"></cc-casino-core-lazy-placeholder>
        <cc-casino-core-lazy-placeholder
            *ngSwitchCase="liveGameIframeCategory"
            [inputData]="{ liveGamesCategory: liveGamesCategory, liveGameInfo: liveGameInfo, lobbyType: lobbyType }"
            [componentName]="'LiveGamesIframeComponent'">
        </cc-casino-core-lazy-placeholder>
        <cc-lmt-category-lobby
            *ngSwitchDefault
            [categoryId]="categoryId"
            [category]="category"
            [isTouch]="isTouch"
            [lobbyType]="lobbyType"
            [gameContainer]="gameContainer">
        </cc-lmt-category-lobby>
    </span>
}
